function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.003,
    height: 30,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30.003 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,25V5h29.999L0,25Z",
    style: {
      fill: "#1eb53a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,5v19.999H0L30,5Z",
    style: {
      fill: "#00a3dd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 5,
    width: 29.999,
    height: 19.999,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "29.982 5 22.914 5 0 20.276 0 25 7.187 25 30 9.792 30 5.027 29.982 5",
    style: {
      fill: "#fcd116"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "29.986 5 25.167 5 0 21.777 0 25 4.932 25 30 8.288 30 5.021 29.986 5",
    style: {
      fill: "#000000"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTz);
export default __webpack_public_path__ + "static/media/TZ.f685aaf6a6fed60d3d236fc9f04061c5.svg";
export { ForwardRef as ReactComponent };